module.exports = __webpack_public_path__ + "img/panelView_blueBg_2_2.e5c12817.png";